
/* Dreame V4: scoped, dependency-free interactive comparison. */
(function () {
  function all(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
  function maxProducts() { return window.matchMedia('(max-width: 749px)').matches ? 2 : 4; }
  function update(panel) {
    var max = maxProducts();
    var checked = all(panel, '[data-dc-check]:checked');
    checked.slice(max).forEach(function (input) { input.checked = false; });
    var cards = all(panel, '[data-dc-choice]');
    var selected = cards.filter(function (card) { return card.querySelector('[data-dc-check]').checked; });
    var count = selected.length;
    panel.querySelector('[data-dc-count]').textContent = count + ' / ' + max + ' selected';
    panel.querySelector('[data-dc-show]').disabled = count < 2;
    panel.querySelector('[data-dc-clear]').disabled = !count;
    var sticky = panel.querySelector('[data-dc-sticky]');
    sticky.hidden = !count || !panel.querySelector('[data-dc-results]').hidden || panel.hidden;
    panel.querySelector('[data-dc-sticky-count]').textContent = count + ' / ' + max + ' selected';
    panel.querySelector('[data-dc-sticky-names]').textContent = selected.map(function (card) { return card.querySelector('.dc-compare__choice-name').textContent.trim(); }).join(' · ');
    panel.querySelector('[data-dc-sticky-show]').disabled = count < 2;
    cards.forEach(function (card) {
      var check = card.querySelector('[data-dc-check]');
      card.classList.toggle('is-selected', check.checked);
      check.disabled = !check.checked && count >= max;
    });
    return selected;
  }
  function render(panel, scroll) {
    var selected = update(panel);
    if (selected.length < 2) return;
    var head = panel.querySelector('[data-dc-head]');
    all(head, 'th:not(.dc-compare__feature)').forEach(function (node) { node.remove(); });
    var rows = all(panel, '[data-dc-row]');
    rows.forEach(function (row) { all(row, 'td').forEach(function (node) { node.remove(); }); });
    selected.forEach(function (card) {
      var th = document.createElement('th'); th.scope = 'col'; th.className = 'dc-compare__product';
      th.appendChild(card.querySelector('[data-dc-details]').content.cloneNode(true)); head.appendChild(th);
      var values = all(card, '[data-dc-value]');
      rows.forEach(function (row, i) {
        var td = document.createElement('td');
        if (values[i]) td.appendChild(values[i].cloneNode(true)); else td.textContent = '/';
        row.appendChild(td);
      });
    });
    panel.querySelector('[data-dc-results]').hidden = false;
    panel.querySelector('[data-dc-sticky]').hidden = true;
    if (scroll) panel.querySelector('[data-dc-results]').scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
  function initialize(root) {
    all(root, '[data-dc-panel]').forEach(function (panel) {
      if (panel.querySelector('[data-dc-check]')) {
        update(panel);
        if (root.getAttribute('data-dc-default') === 'true' && all(panel, '[data-dc-check]:checked').length >= 2) render(panel, false);
      }
    });
  }
  var lastMobile = window.matchMedia('(max-width: 749px)').matches;
  window.addEventListener('resize', function () {
    var currentMobile = window.matchMedia('(max-width: 749px)').matches;
    if (currentMobile === lastMobile) return;
    lastMobile = currentMobile;
    all(document, '[data-dc-panel]').forEach(function (panel) {
      if (!panel.querySelector('[data-dc-check]')) return;
      var wasVisible = !panel.querySelector('[data-dc-results]').hidden;
      update(panel);
      if (wasVisible) render(panel, false);
    });
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-dc-check]')) return;
    var panel = event.target.closest('[data-dc-panel]');
    panel.querySelector('[data-dc-results]').hidden = true;
    update(panel);
  });
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-dc-tab]');
    if (tab) {
      var root = tab.closest('[data-dc-compare]');
      all(root, '[data-dc-tab]').forEach(function (item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
        var panel = root.querySelector('#' + item.getAttribute('aria-controls'));
        if (panel) { panel.hidden = !active; if (panel.querySelector('[data-dc-check]')) update(panel); }
      });
      return;
    }
    var button = event.target.closest('[data-dc-show],[data-dc-sticky-show],[data-dc-clear],[data-dc-edit]');
    if (!button) return;
    var panel = button.closest('[data-dc-panel]');
    if (button.hasAttribute('data-dc-show') || button.hasAttribute('data-dc-sticky-show')) render(panel, true);
    if (button.hasAttribute('data-dc-clear')) {
      all(panel, '[data-dc-check]').forEach(function (check) { check.checked = false; });
      panel.querySelector('[data-dc-results]').hidden = true; update(panel);
    }
    if (button.hasAttribute('data-dc-edit')) panel.querySelector('[data-dc-choices]').scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-dc-tab]');
    if (!tab || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) < 0) return;
    var tabs = all(tab.closest('[data-dc-compare]'), '[data-dc-tab]');
    var idx = tabs.indexOf(tab);
    if (event.key === 'Home') idx = 0;
    else if (event.key === 'End') idx = tabs.length - 1;
    else idx = (idx + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault(); tabs[idx].focus(); tabs[idx].click();
  });
  function start() { all(document, '[data-dc-compare]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (event) { all(event.target, '[data-dc-compare]').forEach(initialize); });
})();
